/* Boost Blenz Books — ebook collection + PDP JS
   - Q&A accordion (one-open-at-a-time)
   - Newsletter form (Klaviyo client subscriptions or Shopify customer signup)
   - PDP gallery thumb switching
   - PDP format selector — update ATC price label on variant change */
(function () {
  // ───── PDP gallery (thumbs swap main cover image) ─────
  document.querySelectorAll('[data-bb-ebook-gallery]').forEach(function (gallery) {
    var mainBook = gallery.querySelector('[data-bb-ebook-view="cover"] img');
    if (!mainBook) return;
    var originalSrc = mainBook.getAttribute('src');
    // Clear srcset on swap — browsers prefer srcset over src, so the swap
    // would silently no-op otherwise.
    gallery.querySelectorAll('[data-bb-ebook-thumb]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        gallery.querySelectorAll('[data-bb-ebook-thumb]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var src = btn.getAttribute('data-img-src') || originalSrc;
        mainBook.removeAttribute('srcset');
        mainBook.removeAttribute('sizes');
        mainBook.setAttribute('src', src);
      });
    });
  });

  // ───── Lightbox for look-inside images (click to zoom full-screen) ─────
  (function () {
    var trigger = document.querySelector('[data-bb-ebook-lookinside]');
    if (!trigger) {
      // Fallback: bind to all look-inside images on the page
      document.querySelectorAll('.bb-ebook-page-spread img').forEach(function (img) {
        img.style.cursor = 'zoom-in';
        img.addEventListener('click', function () { openLightbox(img.src, img.alt); });
      });
      return;
    }
  })();
  function openLightbox(src, alt) {
    var overlay = document.createElement('div');
    overlay.className = 'bb-ebook-lightbox';
    overlay.innerHTML = '<button type="button" class="bb-ebook-lightbox-close" aria-label="Close">&times;</button>' +
      '<img src="' + src + '" alt="' + (alt || '') + '">';
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('bb-ebook-lightbox-close')) {
        document.body.removeChild(overlay);
        document.documentElement.style.overflow = '';
      }
    });
    document.body.appendChild(overlay);
    document.documentElement.style.overflow = 'hidden';
    document.addEventListener('keydown', function escClose(e) {
      if (e.key === 'Escape' && document.body.contains(overlay)) {
        document.body.removeChild(overlay);
        document.documentElement.style.overflow = '';
        document.removeEventListener('keydown', escClose);
      }
    });
  }

  // ───── PDP format selector — keep ATC price + main gallery image in sync ─────
  document.querySelectorAll('[data-bb-ebook-buyform]').forEach(function (form) {
    var priceLabel = form.querySelector('[data-bb-ebook-cta-price]');
    // Find the gallery main image at section level (not just inside the form).
    var section = form.closest('[data-section-type="bb-ebook-product-hero"]');
    var mainImg = section ? section.querySelector('[data-bb-ebook-view="cover"] img') : null;
    form.querySelectorAll('input[type="radio"][name="id"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        var opt = radio.closest('.bb-ebook-format-opt');
        if (!opt) return;
        // Sync ATC price label
        var right = opt.querySelector('.bb-ebook-fo-right');
        if (priceLabel && right && !right.classList.contains('is-soon')) {
          priceLabel.textContent = right.textContent.trim();
        }
        // Sync main gallery image to selected variant's image
        var variantImg = opt.getAttribute('data-variant-image');
        if (mainImg && variantImg) {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.setAttribute('src', variantImg);
        }
      });
    });
  });
  // ───── Q&A accordion ─────
  document.querySelectorAll('[data-bb-ebook-qa]').forEach(function (root) {
    var items = root.querySelectorAll('[data-bb-ebook-qa-item]');
    items.forEach(function (item) {
      var btn = item.querySelector('[data-bb-ebook-qa-q]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var isOpen = item.getAttribute('data-open') === 'true';
        items.forEach(function (other) { other.setAttribute('data-open', 'false'); });
        item.setAttribute('data-open', isOpen ? 'false' : 'true');
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  });

  // ───── Newsletter capture ─────
  //
  // For each per-book signup, we send TWO things to Klaviyo so campaigns + flows
  // can segment by which ebook the subscriber signed up on:
  //
  //   1. profile properties via /client/subscriptions  — `ebook_product`,
  //      `ebook_title`, `signup_source`. Survives across visits; works for
  //      segments like "anyone who signed up for food-as-a-weapon".
  //   2. event via /client/events                      — `Signed Up for Ebook`
  //      with the same properties. Best for triggering a per-book welcome flow,
  //      because each signup is a discrete event (segments only fire on profile
  //      changes; events always fire).
  //
  // If the form has data-klaviyo-list, we send to that list. If not, we fall
  // back to a Shopify customer signup tagged 'newsletter,ebook-page,<handle>'.
  document.querySelectorAll('[data-bb-ebook-capture-form]').forEach(function (form) {
    var statusEl = form.parentNode.querySelector('[data-bb-ebook-capture-status]');
    var klaviyoList = form.getAttribute('data-klaviyo-list') || '';
    var ebookHandle = form.getAttribute('data-ebook-product') || '';
    var ebookTitle = form.getAttribute('data-ebook-title') || '';
    var companyId = (klaviyoList.split(':')[0] || '').trim();
    var listId = klaviyoList.split(':').pop() || '';

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      var email = (emailInput && emailInput.value || '').trim();
      if (!email) return;
      var btn = form.querySelector('button');
      if (btn) { btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = 'Sending…'; }
      if (statusEl) statusEl.textContent = '';

      var done = function (ok, msg) {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Send It'; }
        if (statusEl) statusEl.textContent = msg;
        if (ok && emailInput) emailInput.value = '';
      };

      // Per-book custom properties — same shape for subscription + event.
      var ebookProps = {
        ebook_product: ebookHandle,
        ebook_title: ebookTitle,
        signup_source: 'ebook_pdp'
      };

      if (companyId && listId) {
        // 1. Subscribe + write properties.
        //    https://developers.klaviyo.com/en/reference/create_client_subscription
        var subscribePromise = fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: email,
                      properties: ebookProps
                    }
                  }
                },
                custom_source: 'Boost Blenz Books (' + (ebookHandle || 'ebook') + ')'
              },
              relationships: { list: { data: { type: 'list', id: listId } } }
            }
          })
        });

        // 2. Fire an event so per-book flows can trigger reliably.
        //    Events always fire, even for already-subscribed profiles.
        //    https://developers.klaviyo.com/en/reference/create_client_event
        var eventPromise = fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(companyId), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'event',
              attributes: {
                properties: ebookProps,
                metric: { data: { type: 'metric', attributes: { name: 'Signed Up for Ebook' } } },
                profile: { data: { type: 'profile', attributes: { email: email } } }
              }
            }
          })
        }).catch(function () { /* event is best-effort — don't block the user on it */ });

        subscribePromise.then(function (r) {
          if (r.ok || r.status === 202) done(true, "Thanks — check your inbox.");
          else done(false, "Hmm, that didn't work. Try again?");
        }).catch(function () { done(false, "Network hiccup. Try again?"); });
      } else {
        // Fallback: Shopify customer signup. Append the ebook handle as a tag
        // so admins can still segment by book without Klaviyo configured.
        var tags = 'newsletter,ebook-page';
        if (ebookHandle) tags += ',ebook-' + ebookHandle;
        var fd = new FormData();
        fd.append('form_type', 'customer');
        fd.append('utf8', '✓');
        fd.append('contact[tags]', tags);
        fd.append('contact[email]', email);
        fetch('/contact#contact_form', { method: 'POST', body: fd })
          .then(function () { done(true, "Thanks — you're on the list."); })
          .catch(function () { done(false, "Network hiccup. Try again?"); });
      }
    });
  });
})();
